import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Header } from 'semantic-ui-react';

import './BlogPostNavigationHeader.css';
import { BlogPostPropType } from '../../../../services/proptypes';
import ObjectUtils from '../../../../utils/ObjectUtils';
import FeaturedBlogPost from '../FeaturedBlogPost/FeaturedBlogPost';

export default class BlogPostNavigationHeader extends React.PureComponent {
  render() {
    const { title, description, featuredPostId, posts } = this.props;

    const featuredPost = posts.find(post => {
      return post._id === featuredPostId;
    });

    const isDescription = ObjectUtils.isRenderable(description);
    const isFeaturedPost = ObjectUtils.isRenderable(featuredPost);

    return (
      <React.Fragment>
        {title && (
          <Header as="h1" dividing>
            {title}
          </Header>
        )}

        <Grid stackable>
          {isDescription && (
            <Grid.Column width={isFeaturedPost ? 6 : 16}>
              <p>{description}</p>
            </Grid.Column>
          )}

          {isFeaturedPost && (
            <Grid.Column width={isDescription ? 10 : 16}>
              <FeaturedBlogPost {...featuredPost} />
            </Grid.Column>
          )}
        </Grid>
      </React.Fragment>
    );
  }
}

BlogPostNavigationHeader.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  featuredPostId: PropTypes.number,
  posts: PropTypes.arrayOf(BlogPostPropType).isRequired,
};

BlogPostNavigationHeader.defaultProps = {
  title: 'Blog',
  description: '',
  featuredPostId: null,
};
